// frontend/src/App/lazyComponents.ts
import { lazy } from 'react';

// 🚀 CODE SPLITTING: Cargar páginas bajo demanda con React.lazy
export const DashboardSystem = lazy(() =>
	import('../features/users/pages/System/DashboardSystem')
);
export const CreateUser = lazy(() =>
	import('../features/users/pages/System/CreateUser')
);
export const UpdateUser = lazy(() =>
	import('../features/users/pages/System/UpdateUser')
);
export const DeleteUser = lazy(() =>
	import('../features/users/pages/System/DeleteUser')
);
export const CompanyInfo = lazy(() =>
	import('../features/users/pages/System/CompanyInfo')
);
export const AuditTrail = lazy(() =>
	import('../features/users/pages/System/AuditTrail')
);
export const CreateSystemUser = lazy(() =>
	import('../features/superadmin/pages/SuperAdmin/CreateSystemUser')
);
export const SuperAdminDashboard = lazy(() =>
	import('../features/superadmin/pages/SuperAdmin/SuperAdminDashboard')
);
export const Casos = lazy(() =>
	import('../features/formularios/pages/Responsables/Casos')
);
export const ListadeProcesos = lazy(() =>
	import('../features/processes/pages/Sostenibilidad/ListadeProcesos')
);
export const ExtraccionDashboard = lazy(() =>
	import('../features/metrics/pages/Extraccion/ExtraccionDashboard')
);
export const ResetPassword = lazy(() =>
	import('../features/authentication/pages/auth/ResetPassword')
);
export const VistaFormulario = lazy(() =>
	import('../features/formularios/pages/Responsables/VistaFormulario')
);
export const VistaPregunta = lazy(() =>
	import('../features/formularios/components/VistaPregunta')
);
export const VistaProcesoAcabado = lazy(() =>
	import('../features/formularios/components/VistaProcesoAcabado')
);
